module.exports = __webpack_public_path__ + "static/media/goldbounce.03b53e04.png";